import { GlobalProperty } from '../../constants';
import { Helper } from '../Helper';
export class GetArgumentHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.getGlobalProperty({ property: GlobalProperty.Arguments }));
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=GetArgumentHelper.js.map
